export default "__VITE_ASSET__BWGhchf8__"